<template>
  <div class="activity-popup ym-mw-component-fixed-max"
       :class="{ 'hidden': hidePopup }"
       v-ym-report:MARKETING_AD_ACTIVITY_POPUP_CLICK|MARKETING_AD_ACTIVITY_POPUP_EXPOSURE=
         "{ ...activityInfo, ymReporterRecordEntrySource: true }"
       @click="handleClosePopup"
  >
    <div class="content">
      <ym-img class="img"
              :src="activityInfo.cover"
              alt="活动图"
              @click="handleActivityDetail"
      />
      <div class="close-icon"
           @click.stop="handleClosePopup"
      >
        <ym-icon name="round-close"
        />
      </div>
    </div>
  </div>
</template>

<script>
  import { locationHref, setToStorage, getFromStorage } from '@/utils/index';

  export default {
    name: 'ActivityPopup',
    props: {
      activityInfo: {
        type: Object,
        default() {
          return {};
        },
      },
    },
    data() {
      return {
        hidePopup: false,
      };
    },
    methods: {
      fetchData() {
        this.fetchLocalStorage();
      },
      handleActivityDetail() {
        this.handleSetLocalStorage();
        locationHref(this.activityInfo.url);
      },
      // 判断缓存
      fetchLocalStorage() {
        const now = new Date().getTime();
        const value = getFromStorage(this.activityInfo.storageKey);
        if (value && now < value) {
          this.hidePopup = true;
        }
      },
      handleSetLocalStorage() {
        const now = new Date().getTime();
        const expires = now + (this.activityInfo.interval * 1000);
        setToStorage(this.activityInfo.storageKey, expires);
      },
      handleClosePopup() {
        this.handleSetLocalStorage();
        this.hidePopup = true;
      },
    },
    created() {
      this.fetchData();
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .activity-popup {
    position: fixed;
    top: 0;
    bottom: 0;
    z-index: @z-index-extra-extra-large;
    background: fade(@color-black, 60%);
    display: flex;
    align-items: center;
    justify-content: center;
    &.hidden {
      display: none;
    }
  }

  .content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 690px;
    .img {
      width: 100%;
    }
  }

  .close-icon {
    margin-top: @size-base;
    color: @color-white;
    font-size: @font-size-largest;
  }

</style>
